import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, CREATE_GALLERY } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";

/** Keeps the existing POST request and response contract. */
export function createGallery(data, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_GALLERY}`, data, configReq(token));
}
